import styled from '@emotion/styled';
import { Popover, Typography } from 'antd';
import React from 'react';
import { TTBTableDataType } from '../../../../types/tryThenBuy';
import { getSKUForProduct } from '../../../../utils/ttbImageConfig';

interface ProductNameColumnProps {
  record: TTBTableDataType;
  className?: string;
}

enum SelectNodeDetail {
  GENDER = 'Gender',
  HAND = 'Hand',
  LOFT = 'Loft',
  SHAFT_MODEL = 'Shaft Model',
  SHAFT_VENDOR = 'Shaft Vendor',
  SHAFT_FLEX = 'Shaft Flex',
  TIPPING_ADJUSTMENT = 'Tipping Adjustment',
  LENGTH_ADJUSTMENT = 'Length Adjustment',
  GRIP_VENDOR = 'Grip Vendor',
  GRIP_MODEL = 'Grip Model',
  GRIP_WRAPS = 'Grip Wraps',
  GRIP_LOGO = 'Grip Logo',
}

const ContentProductInfo = (props: any) => {
  const nodes = props.selectedNodes;
  return (
    <StyledContentProductInfo>
      <p>
        <span className="nodes-name">{SelectNodeDetail.GENDER} </span>
        <span className="nodes-value">{nodes?.find((x: any) => x.name === SelectNodeDetail.GENDER)?.option?.name}</span>
      </p>
      <p>
        <span className="nodes-name">{SelectNodeDetail.HAND} </span>
        <span className="nodes-value">{nodes?.find((x: any) => x.name === SelectNodeDetail.HAND)?.option?.name}</span>
      </p>
      <p>
        <span className="nodes-name">{SelectNodeDetail.LOFT} </span>
        <span className="nodes-value">{nodes?.find((x: any) => x.name === SelectNodeDetail.LOFT)?.option?.name}</span>
      </p>
      <p style={{ marginBottom: 10 }} />
      <p>
        <span className="nodes-name">{SelectNodeDetail.SHAFT_MODEL} </span>
        <span className="nodes-value">
          {nodes?.find((x: any) => x.name === SelectNodeDetail.SHAFT_MODEL)?.option?.name}
        </span>
      </p>
      <p>
        <span className="nodes-name">{SelectNodeDetail.SHAFT_VENDOR} </span>
        <span className="nodes-value">
          {nodes?.find((x: any) => x.name === SelectNodeDetail.SHAFT_VENDOR)?.option?.name}
        </span>
      </p>
      <p>
        <span className="nodes-name">{SelectNodeDetail.SHAFT_FLEX} </span>
        <span className="nodes-value">
          {nodes?.find((x: any) => x.name === SelectNodeDetail.SHAFT_FLEX)?.option?.name}
        </span>
      </p>
      <p>
        <span className="nodes-name">{SelectNodeDetail.TIPPING_ADJUSTMENT} </span>
        <span className="nodes-value">
          {nodes?.find((x: any) => x.name === SelectNodeDetail.TIPPING_ADJUSTMENT)?.option?.name}
        </span>
      </p>
      <p>
        <span className="nodes-name">{SelectNodeDetail.LENGTH_ADJUSTMENT} </span>
        <span className="nodes-value">
          {nodes?.find((x: any) => x.name === SelectNodeDetail.LENGTH_ADJUSTMENT)?.option?.name}
        </span>
      </p>
      <p style={{ marginBottom: 10 }} />
      <p>
        <span className="nodes-name">{SelectNodeDetail.GRIP_VENDOR} </span>
        <span className="nodes-value">
          {nodes?.find((x: any) => x.name === SelectNodeDetail.GRIP_VENDOR)?.option?.name}
        </span>
      </p>
      <p>
        <span className="nodes-name">{SelectNodeDetail.GRIP_MODEL} </span>
        <span className="nodes-value">
          {nodes?.find((x: any) => x.name === SelectNodeDetail.GRIP_MODEL)?.option?.name}
        </span>
      </p>
      <p>
        <span className="nodes-name">{SelectNodeDetail.GRIP_WRAPS} </span>
        <span className="nodes-value">
          {nodes?.find((x: any) => x.name === SelectNodeDetail.GRIP_WRAPS)?.option?.name}
        </span>
      </p>
      <p>
        <span className="nodes-name">{SelectNodeDetail.GRIP_LOGO} </span>
        <span className="nodes-value">
          {nodes?.find((x: any) => x.name === SelectNodeDetail.GRIP_LOGO)?.option?.name}
        </span>
      </p>
    </StyledContentProductInfo>
  );
};

const ProductTitle = (props: any) => {
  return <span style={{ fontSize: 16, fontWeight: 'bold' }}>{props?.productName}</span>;
};

export default React.memo((props: ProductNameColumnProps) => {
  const { record, className } = props;

  const selectedNodes = record?.productInfo?.cTmCustomconfiguratorNodes?.selectedNodes;

  let imageURL = record?.productImageUrl;
  if (!imageURL) {
    const sku = getSKUForProduct(record?.productName, record?.productId);
    if (sku) {
      imageURL = `https://www.taylormadegolf.com/on/demandware.static/-/Sites-tmag-master-catalog/default/zoom/${sku}_zoom_D.jpg`;
    }
  }

  return (
    <StyledProductContainer className={className || ''}>
      <Popover
        content={<ContentProductInfo selectedNodes={selectedNodes} />}
        title={<ProductTitle productName={record?.productName} />}
        className="popover-info"
      >
        {imageURL ? (
          <div className="image" style={{ backgroundImage: `url('${imageURL}')` }} />
        ) : (
          <div className="image" />
        )}
        <Typography.Text>{record.productName}</Typography.Text>
      </Popover>
    </StyledProductContainer>
  );
});

const StyledProductContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  .popover-info {
    display: flex;
    align-items: center;
    padding-left: 0.5rem;
  }
  .image {
    width: 3.125rem;
    height: 3.125rem;
    background-color: #eee;
    background-size: cover;
    background-position: center center;
    border: 1px solid #eee;
    margin-right: 0.5rem;
  }
  span {
    font-weight: 600;
  }

  text-align: left !important;

  .ant-typography {
    min-width: 125px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ant-popover-title {
    font-weight: bold;
    font-size: 16px;
  }
`;

const StyledContentProductInfo = styled.div`
  p {
    margin-bottom: 0;
    font-size: 13px;
  }

  & .nodes-value {
    color: #97979d;
    font-weight: 600;
  }

  & .nodes-name {
    font-weight: 700;
  }
`;
